import { DayHeaderContentArg } from '@fullcalendar/core';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import React from 'react';

import * as Styled from './date-header.style';

export const DateHeader: React.FC<DayHeaderContentArg> = ({
  date,
  isToday,
}) => (
  <Styled.DateHeaderContainer $isToday={isToday}>
    <Typography variant="buttonSmall" component="span">
      {format(date, 'EEE')}
    </Typography>
    <Styled.CalendarDay $isToday={isToday}>
      {format(date, 'd')}
    </Styled.CalendarDay>
  </Styled.DateHeaderContainer>
);
